import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';


@Component({
  selector: 'app-highc',
  standalone: true,
  templateUrl: './highc.component.html',
  styleUrls: ['./highc.component.scss'],
  imports: [HighchartsChartModule]
})
export class HighcComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts; // required
  chartConstructor: string = 'chart'; // optional string, defaults to 'chart'
  chartOptions: Highcharts.Options = { 
    /* series: [{
    data: [1, 2, 3,2,4,5,4,3,6,4,3],
    type: 'line'
  }]  */}
  ; // required
  
  
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  constructor() { }

  ngOnInit(): void {
    let value = 1.0101
    let lista = [value]
    for(let i=0;i<1000;i++){
      let r = Math.random()
      value += Math.floor((r*2-1)*100)/10000
      lista.push(value)
    }
    this.chartOptions = {
      series: [{
        data: lista ,
        type: 'line'}
      ]
      }
    }
  


}
